import React, { useState } from 'react';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { Overview } from './components/dashboard/Overview';
import { Analytics } from './components/dashboard/Analytics';
import { ApiKeys } from './components/dashboard/ApiKeys';
import { Billing } from './components/dashboard/Billing';
import { Settings } from './components/dashboard/Settings';
import { LoginScreen } from './components/auth/LoginScreen';
import { ThemeProvider } from './contexts/ThemeContext';
import { ApiProvider } from './contexts/ApiContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const DashboardContent: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  const getPageTitle = (tab: string) => {
    switch (tab) {
      case 'overview':
        return 'Dashboard Overview';
      case 'analytics':
        return 'Usage Analytics';
      case 'keys':
        return 'API Keys';
      case 'teams':
        return 'Team Management';
      case 'billing':
        return 'Billing & Usage';
      case 'reports':
        return 'Reports';
      case 'settings':
        return 'Settings';
      default:
        return 'Ask Engine Dashboard';
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'analytics':
        return <Analytics />;
      case 'keys':
        return <ApiKeys />;
      case 'billing':
        return <Billing />;
      case 'teams':
        return (
          <div className="chart-container">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">Team Management</h2>
            <p className="text-gray-600 dark:text-gray-400">Team management features coming soon...</p>
          </div>
        );
      case 'reports':
        return (
          <div className="chart-container">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">Reports</h2>
            <p className="text-gray-600 dark:text-gray-400">Detailed reporting features coming soon...</p>
          </div>
        );
      case 'settings':
        return <Settings />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} />
      
      <div className="ml-64 min-h-screen">
        <Header title={getPageTitle(activeTab)} />
        
        <main className="p-6">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ApiProvider>
          <DashboardContent />
        </ApiProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
